import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function OAuthCallback() {
  const [params] = useSearchParams();
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error) {
      navigate(`/login?error=${error}`);
      return;
    }

    if (token) {
      const user = {
        id:    params.get('id'),
        name:  params.get('name'),
        email: params.get('email'),
        role:  params.get('role'),
      };
      loginUser(token, user);
      navigate('/');
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <div className="text-center">
        <i className="fa fa-spinner fa-spin fa-3x text-primary mb-3"></i>
        <p className="text-muted">Completing sign in...</p>
      </div>
    </div>
  );
}
